import type { TealiumEventData } from 'src/types/trackingData';

import { EVENT_NAME_INTERACTION } from '.';

export const addVideoEventData: TealiumEventData = {
  linkName: 'ecaja-add-video',
  eventName: [EVENT_NAME_INTERACTION],
};

export const validateVideoEventData: TealiumEventData = {
  linkName: 'ecaja-video-validated',
  eventName: ['video-validated'],
};

export const removeVideoEventData: TealiumEventData = {
  linkName: 'ecaja-video-removed',
  eventName: [EVENT_NAME_INTERACTION],
};
